import type {
  EmailTemplateContentDto,
  EmailTemplateBlockDto,
} from "@babackapp/private-api-client/types";

export type EmailOverrides = {
  subject?: Record<string, string>;
  customBlocks?: Record<string, unknown>;
  hiddenBlocks?: string[];
};

export function applyEmailOverrides(
  content: EmailTemplateContentDto,
  subject: Record<string, string>,
  overrides: EmailOverrides | null | undefined,
): { content: EmailTemplateContentDto; subject: Record<string, string> } {
  if (!overrides) {
    return { content, subject };
  }

  const { customBlocks, hiddenBlocks } = overrides;
  const hiddenSet = new Set(hiddenBlocks ?? []);

  const mergedContent =
    customBlocks || hiddenBlocks
      ? {
          ...content,
          beforeBlocks: applyToSection(content.beforeBlocks, customBlocks, hiddenSet),
          insideBlocks: applyToSection(content.insideBlocks, customBlocks, hiddenSet),
          afterBlocks: applyToSection(content.afterBlocks, customBlocks, hiddenSet),
        }
      : content;

  const mergedSubject = overrides.subject
    ? { ...subject, ...overrides.subject }
    : subject;

  return { content: mergedContent, subject: mergedSubject };
}

function applyToSection(
  blocks: EmailTemplateBlockDto[],
  customBlocks: Record<string, unknown> | undefined,
  hiddenSet: Set<string>,
): EmailTemplateBlockDto[] {
  return blocks
    .filter((block) => !hiddenSet.has(block.id))
    .map((block) => {
      if (customBlocks && block.id in customBlocks) {
        return customBlocks[block.id] as EmailTemplateBlockDto;
      }
      return block;
    });
}
